import { VACANT_POSITION_END_DATE } from 'routes/HumanResourcesModule/business/definitions';
import { VacantPosition } from 'routes/HumanResourcesModule/business/types';

export function getHasNoEndDate(vacantsData: VacantPosition[]): boolean {
    return vacantsData.every((item) => !item[VACANT_POSITION_END_DATE]);
}
